<template>
  <div class="container">
    <TopPanel>我的订单</TopPanel>
    <div class="filters">
      <div class="order-status-row">
        <span class="lblStatus">状态</span>
        <order-filter
          class="switch"
          :list="orderStatusList"
          @change="changeOrderSelectStatus"
        ></order-filter>
      </div>
      <div class="order-status-row">
        <span class="lblStatus">订单时间</span>
        <order-filter
          class="switch"
          :list="orderTimeSelectList"
          @change="changeOrderSelectTime"
        ></order-filter>
      </div>
    </div>
    <div class="table-header-panel">
      <div>产品名称</div>
      <div>类型</div>
      <div>服务期限</div>
      <div>实付款(元)</div>
      <div>订单状态</div>
      <div>操作</div>
    </div>
    <div class="panel-content" v-if="orderList">
      <order-list-item
        v-for="(item, index) in orderList"
        :key="index"
        :orderId="item.orderId"
        :productId="item.productId"
        :createTime="item.createTime"
        :goodsName="item.goodsName"
        :productTypeName="item.productTypeName"
        :periodDescription="item.periodDescription"
        :amount="item.actualAmount"
        :orderStatus="item.orderStatus"
        :expireTime="item.expireTime"
        :productType="
          item.products && item.products.length > 0
            ? item.products[0].productType
            : 0
        "
        :targetId="
          item.products && item.products.length > 0
            ? item.products[0].targetId
            : 0
        "
      ></order-list-item>
      <div class="more" v-show="!pageEnd" @click="loadOrders()">
        点击查看更多
      </div>
    </div>
  </div>
</template>

<script>
import OrderFilter from '@/components/Mine/OrderFilter.vue'
import OrderListItem from '@/components/Mine/OrderListItem.vue'
import TopPanel from '@/components/Mine/TopPanel'
import dayjs from 'dayjs'
import { queryOrderDetails } from '@/api/order'
export default {
  name: 'Orders',
  props: {},
  components: { TopPanel, OrderFilter, OrderListItem },
  data() {
    return {
      orderStatusList: [
        { name: '全部', index: 0, value: -1 },
        { name: '已完成', index: 1, value: 3 },
        { name: '待支付', index: 2, value: 1 },
        { name: '已关闭', index: 3, value: 4 }
      ],
      orderTimeSelectList: [
        { name: '全部', index: 0, value: 0 },
        { name: '近一周', index: 1, value: 1 },
        { name: '近一月', index: 2, value: 2 },
        { name: '近三月', index: 3, value: 3 },
        { name: '近半年', index: 4, value: 4 },
        { name: '近一年', index: 5, value: 5 }
      ],
      timeList: [
        { startDate: null, endDate: null },
        {
          startDate: dayjs().add(-7, 'day').format('YYYY-MM-DD'),
          endDate: dayjs().format('YYYY-MM-DD')
        },
        {
          startDate: dayjs().add(-1, 'month').format('YYYY-MM-DD'),
          endDate: dayjs().format('YYYY-MM-DD')
        },
        {
          startDate: dayjs().add(-3, 'month').format('YYYY-MM-DD'),
          endDate: dayjs().format('YYYY-MM-DD')
        },
        {
          startDate: dayjs().add(-6, 'month').format('YYYY-MM-DD'),
          endDate: dayjs().format('YYYY-MM-DD')
        },
        {
          startDate: dayjs().add(-1, 'year').format('YYYY-MM-DD'),
          endDate: dayjs().format('YYYY-MM-DD')
        }
      ],

      orderStatus: -1,
      orderTimeRange: { startDate: null, endDate: null },
      orderList: [],
      viewState: '',
      pageEnd: false,
      pollTimerId: 0
    }
  },
  created() {
    this.loadOrders()
  },
  beforeDestroy() {
    this.stopPolling()
  },
  methods: {
    changeOrderSelectStatus(value) {
      this.orderStatus = value
      this.viewState = ''
      this.orderList = []
      this.loadOrders()
    },
    changeOrderSelectTime(value) {
      this.orderTimeRange = this.timeList[value]
      this.viewState = ''
      this.orderList = []
      this.loadOrders()
    },
    async loadOrders() {
      var parm = {
        startDate: this.orderTimeRange.startDate,
        endDate: this.orderTimeRange.endDate,
        orderStatus: this.orderStatus === -1 ? '' : this.orderStatus,
        direction: this.viewState ? 2 : 0
      }
      const res = await queryOrderDetails(parm, this.viewState)
      if (res && res.detail.list) {
        this.viewState = res.result.viewState
        this.pageEnd = res.detail.end
        const list = res.detail.list
        if (res.detail.flush) {
          this.orderList = list
        } else {
          this.orderList = this.orderList.concat(list)
        }
        if (this.orderList.some(x => x.orderStatus === 1)) {
          this.startPolling()
        }
      }
    },
    async silentRefresh() {
      const parm = {
        startDate: this.orderTimeRange.startDate,
        endDate: this.orderTimeRange.endDate,
        orderStatus: this.orderStatus === -1 ? '' : this.orderStatus,
        direction: 0
      }
      const res = await queryOrderDetails(parm, '')
      if (res && res.detail.list) {
        const refreshedList = res.detail.list
        this.orderList = this.orderList.map(order => {
          const refreshed = refreshedList.find(x => x.orderId === order.orderId)
          return refreshed || order
        })
        if (!this.orderList.some(x => x.orderStatus === 1)) {
          this.stopPolling()
        }
      }
    },
    startPolling() {
      if (this.pollTimerId) return
      this.pollTimerId = setInterval(() => {
        this.silentRefresh()
      }, 60000)
    },
    stopPolling() {
      if (this.pollTimerId) {
        clearInterval(this.pollTimerId)
        this.pollTimerId = 0
      }
    }
  },
  computed: {}
}
</script>

<style lang="scss" scoped>
.container {
  width: 828px;
  // height: 1225px;
  background-color: #ffffff;
  border: solid 1px #ebebeb;
  margin-left: 30px;
  margin-top: 0px;
  display: flex;
  flex-direction: column;
}
.filters {
  width: 768px;
  height: 103px;
  display: flex;
  flex-direction: column;
}
.order-status-row {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  height: 26px;
  margin-top: 20px;
  margin-left: 30px;
  position: relative;
}
.lblStatus {
  height: 14px;
  font-family: MicrosoftYaHei;
  font-size: 16px;
  color: #262626;
  margin-top: 6px;
}
.switch {
  left: 87px;
  position: absolute;
}
.table-header-panel {
  height: 40px;
  display: flex;
  background-color: #f0f0f0;
  line-height: 40px;
  margin: 30px 30px 0;
  flex: 0 0 40px;
}
.table-header-panel > div {
  height: 100%;
  width: 138px;
  font-size: 14px;
  color: #858585;
  text-align: center;
  &:nth-child(2),
  &:nth-child(3),
  &:nth-child(4) {
    width: 118px;
  }
}
.panel-content {
  padding-bottom: 20px;
}
.more {
  width: 100%;
  height: 40px;
  margin: 30px auto;
  font-size: 14px;
  line-height: 40px;
  color: #858585;
  background-color: #fafafa;
  text-align: center;
  cursor: pointer;
}
</style>
